export const AllRowsSelectedMessage = "All rows got selected";
export const AllRowsUnselectedMessage = "All rows got unselected";
export const ClickableRowAnnouncement = "Row {0}. Clickable";
export const ClickableRowAnnouncementWithSize = "Row {0} of {1}. Clickable";
export const ColumnButtonSizerLeft = "Move column sizer left";
export const ColumnButtonSizerLeftAriaLabel = "Compress column to the left";
export const ColumnButtonSizerRight = "Move column sizer right";
export const ColumnButtonSizerRightAriaLabel = "Expand column to the right";
export const ColumnSizerLabel = "{0} column sizer";
export const ColumnSortedAscendingAnnouncement = "Column sorted ascending";
export const ColumnSortedDescendingAnnouncement = "Column sorted descending";
export const DropdownSelection = "Dropdown Selection";
export const EmptyColumnHeaderLabel = "Blank";
export const ListItem = "listitem";
export const MoreActions = "More actions";
export const MoreTooltip = "More options";
export const NoMoreActions = "No actions";
export const RemovePillLabel = "Remove {0}";
export const RowAnnouncement = "Row {0}";
export const RowAnnouncementWithSize = "Row {0} of {1}";
export const SelectAllRowsLabel = "Select all rows";
export const SelectionColumnLabel = "Selection column";
export const SelectRowLabel = "Select row";
export const ShowLess = "Show less";
export const ShowMore = "Show more";
export const SizerAnnouncement = "Drag sizer to resize column. Click to control sizing using buttons.";
export const Started = "Started {0}";
export const VirtualizationDisabled = "Virtualization disabled";
export const VirtualizedListLabelFormat = "{0}. Use ctrl + alt + v to disable list virtualization";
